const localization = {
    cannot_delete_default_language: '{{languageTag}} ถูกตั้งเป็นภาษาหลักของคุณและไม่สามารถลบได้',
    invalid_translation_structure: 'โครงสร้างข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง',
};
export default Object.freeze(localization);
